export default __webpack_public_path__ + "static/bytte-ikon-figma-095e376d0496d0bb027e459a15739db2.png";